import styled from 'styled-components';
import Background from '../assets/raodmap.png';
import CompletedImage from '../assets/earthCompleted.png';
import FlexBox, { FlexGrow } from './FlexBox';
import { useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { UserContext } from '../context/UserContext';
import LoadingSpinner from './LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import {
  calculateWidth,
  generateRoadmap,
  generateRoadmapDates,
} from '../hooks/generateCalendar';
import RoadmapItem from './RoadmapItem';
import { PendingRing, PendingLabel } from './RoadmapItem';
import StyledTooltip from './StyledTooltip';
import { SemesterContext } from '../context/SemesterContext';
import Planet1 from '../assets/planets/edited1.svg';
import Planet2 from '../assets/planets/edited2.svg';
import Planet3 from '../assets/planets/edited3.svg';
import Planet4 from '../assets/planets/edited4.svg';
import Planet5 from '../assets/planets/unedited5.svg';
import Planet6 from '../assets/planets/unedited6.svg';
import Planet7 from '../assets/planets/unedited7.svg';
import Planet8 from '../assets/planets/unedited8.svg';
import Planet9 from '../assets/planets/unedited9.svg';
import { useScreenClass } from 'react-grid-system';
import {
  IconButton,
  Tooltip,
  tooltipClasses,
  styled as styledMui,
  TooltipProps,
} from '@mui/material';
import React from 'react';
import { StyledText, TextSize } from './Text';
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment';
import { handleJWTError } from '../hooks/jwtErrHandler';
import { UniversityContext } from '../context/UniversityContext';

type Props = {
  isOpen: boolean;
  setOpen?: any;
  onDismiss?: () => void;
  onConfirm: (date: Date | null) => void;
  onClose?: () => void;
};
const LightTooltip = styledMui(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[5],
  },
}));
export type FlexProps = {
  width: string;
};
const CustomFlex = styled(FlexGrow) <FlexProps>`
  z-index: 1;
  position: absolute;
  top: calc(100vh - 70%);
  top: -moz-calc(100vh - 70%);
  top: -o-calc(100vh - 70%);
  top: -webkit-calc(100vh - 70%);
  width: ${({ width }) => width};
  min-width: 100%;
  left: 0;
  height: 183px;
`;
const Hr = styled.hr`
  width: 100%;
  background: #feffff;
  box-shadow: 0px 0px 6px 10px #2585b9;
  border-radius: 10px;
  height: 10px;
  margin-top: 84px;
`;
const Days = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 0px;

  position: absolute;
  width: max-content;
  height: 26px;
  left: 0px;
  top: 10px;

  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(44px);
`;
const WeekBox = styled(FlexBox)`
  min-width: 295px;
  width: 295px;
  max-width: 295px;
  border-right: 1px solid #e35a65;
`;
const Day = styled.div`
  padding: 0px 0px;
  position: static;
  height: 18px;
  left: 0px;
  top: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  letter-spacing: 0.2px;

  color: #ffffff;
`;
const Planets: Array<any> = [
  Planet1,
  Planet2,
  Planet3,
  Planet4,
  Planet5,
  Planet6,
  Planet7,
  Planet8,
  Planet9,
];
function groupBy(xs: Array<any>, key: string) {
  return xs.reduce(function (rv, x) {
    (rv[x.competency_card[key]] = rv[x.competency_card[key]] || []).push(x);
    return rv;
  }, {});
}
export default function CustomRoadmap({ setCredits, view }: any) {
  const screenClass = useScreenClass();
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const currentUser = userContext.user;
  const [roadMaps, setRoadMaps] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [width, setWidth] = useState<string>('5000px');
  const [roadmapId, setRoadmapId] = useState<string>();
  const [dates, setDates] = useState<Array<any>>([]);
  const [events, setEvents] = useState<Array<any>>([]);
  const [enrolled, setEnrolled] = useState<boolean>(false);
  const semesterContext = useContext(SemesterContext);
  const universityContext = useContext(UniversityContext);

  const isLarge = useMemo(() => ['xxl'].includes(screenClass), [screenClass]);
  useEffect(() => {
    if (currentUser.id && semesterContext.selectedSemester?.label) {
      fetchVersion(currentUser.id)
      fetchRoadmap();
    }
  }, [currentUser, semesterContext, view]);
  const fetchVersion = (id: string) => {
    setEnrolled(true)
    axios
      .get(`/student/version?student_id=${id}&semester_name=${semesterContext.selectedSemester?.label}&program_id=${userContext.user?.programs?.[0]?.id}`)
      .then((res) => {})
      .catch((error) => {
        if (error.response.data.error === 'Student not enrolled for this semester') {
          setEnrolled(false)
        } else {
          console.log("An error occurred:", error);
        }
      })
  }
  const fetchRoadmap = () => {
    setLoading(true);
    axios
      .get(
        `/roadmap/milestones?student_id=${currentUser.id}&year=${semesterContext.selectedSemester?.year}&semester=${semesterContext.selectedSemester?.label}&program_name=${userContext?.user?.programs?.[0]?.program_name || universityContext.selectedProgram?.short_name}`,
      )
      .then((res) => {
        const customArray: any[] = [];
        const sortedArray: any[] = [];
        res.data.roadmaps.forEach((roadmap: any) => {
          setRoadmapId(roadmap.id);
          setCredits(roadmap.credits);
          roadmap.milestones.forEach((miles: any) => {
            if (miles.competency_card?.status !== 'Incomplete') {
              customArray.push(miles);
            }
          });
          const array = groupBy(customArray, 'template_pillar_id');
          Object.entries(array).forEach((entry) => {
            const [key, value] = entry;
            (value as Array<any>).forEach((element, index) => {
              if (index > 9) {
                element.planetIndex = index - 9;
              } else {
                element.planetIndex = index;
              }
              sortedArray.push(element);
            });
          });
        });
        // const earliest = sortedArray.reduce(function (pre, cur) {
        //   return Date.parse(pre.start_date) > Date.parse(cur.start_date)
        //     ? cur
        //     : pre;
        // });
        // const latest = sortedArray.reduce(function (pre, cur) {
        //   return Date.parse(pre.start_date) < Date.parse(cur.start_date)
        //     ? cur
        //     : pre;
        // });
        // const earliest = semesterContext.selectedSemester?.start_date;
        // const latest = semesterContext.selectedSemester?.end_date;
        const earliest = moment(semesterContext.selectedSemester?.start_date).startOf('month').format('YYYY-MM-DD');
        const latest = moment(semesterContext.selectedSemester?.end_date).endOf('month').format('YYYY-MM-DD');
        setWidth(calculateWidth(earliest, latest, view));
        setDates(
          generateRoadmapDates(earliest, latest, view, isLarge ? 7 : 4, {
            add_drop_date: semesterContext.selectedSemester?.add_drop_date,
            final_assess_date:
              semesterContext.selectedSemester?.final_assess_date,
          }),
        );
        setEvents(generateRoadmap(sortedArray, earliest, view));
        setRoadMaps(res.data.roadmaps);
        setLoading(false);
      })
      .catch((err) => {
        setCredits('0');
        setEvents([]);
        // const earliest = semesterContext.selectedSemester?.start_date;
        // const latest = semesterContext.selectedSemester?.end_date;
        const earliest = moment(semesterContext.selectedSemester?.start_date).startOf('month').format('YYYY-MM-DD');
        const latest = moment(semesterContext.selectedSemester?.end_date).endOf('month').format('YYYY-MM-DD');
        setWidth(calculateWidth(earliest, latest, view));
        setDates(
          generateRoadmapDates(earliest, latest, view, isLarge ? 7 : 4, {
            add_drop_date: semesterContext.selectedSemester?.add_drop_date,
            final_assess_date:
              semesterContext.selectedSemester?.final_assess_date,
          }),
        );
        setLoading(false);
        handleJWTError(err);
      });
  };
  const redirectDetail = (id: string) => {
    navigate(`/roadmap/detail?rid=${roadmapId}&mid=${id}`);
  };

  if (!enrolled) {
    return (
      <FlexGrow style={{ textAlign: 'center', paddingTop: '30px' }}>
        <StyledText
          color="red"
          fontWeight="700"
          textSize={TextSize.default}>
          Student not enrolled for {semesterContext.selectedSemester?.label}
        </StyledText>
      </FlexGrow>
    )
  }

  return (
    <>
      <FlexBox
        style={{
          height: '100%',
          backgroundImage: `url(${Background})`,
          backgroundRepeat: 'repeat',
          width: width,
          padding: 0,
          position: 'relative',
          minWidth: '100%',
          backgroundSize: 'cover',
        }}>
        <Days>
          {dates.map((ele, index) => (
            <>
              {ele.add_drop_date ? (
                <WeekBox key={index}>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day style={{ color: '#00ff10' }}>{ele.start}</Day>
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    {/* <Day>~</Day> */}
                    <LightTooltip
                      title={
                        <React.Fragment>
                          <StyledText>Add drop date : {ele.exact_date}</StyledText>
                        </React.Fragment>
                      }
                      arrow>
                      <IconButton style={{ padding: 0, verticalAlign: 'top' }}>
                        <InfoIcon style={{ color: '#00ff10' }} />
                      </IconButton>
                    </LightTooltip>
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day style={{ color: '#00ff10' }}>{ele.end}</Day>
                  </FlexGrow>
                </WeekBox>
              ) : ele.final_assess_date ? (
                <WeekBox key={index}>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day style={{ color: 'yellow' }}>{ele.start}</Day>
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <LightTooltip
                      title={
                        <React.Fragment>
                          <StyledText>Final assessment date : {ele.exact_date}</StyledText>
                        </React.Fragment>
                      }
                      arrow>
                      <IconButton style={{ padding: 0, verticalAlign: 'top' }}>
                        <InfoIcon style={{ color: 'yellow' }} />
                      </IconButton>
                    </LightTooltip>
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day style={{ color: 'yellow' }}>{ele.end}</Day>
                  </FlexGrow>
                </WeekBox>
              ) : (
                <WeekBox key={index}>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day>{ele.start}</Day>
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day>~</Day>
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: 'center' }}>
                    <Day>{ele.end}</Day>
                  </FlexGrow>
                </WeekBox>
              )}
            </>
          ))}
        </Days>
        <CustomFlex width={width} style={{ zIndex: 1 }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <Hr />
              {events.map((item: any, index) => (
                <>
                  {item.status === 'Active' || 'Planned' ? (
                    <StyledTooltip
                      key={index}
                      graphics={item.competency_card.graphics}
                      header={item.competency_card.title}
                      description={item.competency_card.description}>
                      <RoadmapItem
                        onClick={() => {
                          redirectDetail(item.id);
                        }}
                        backgroundElement={Planets[item.planetIndex]}
                        backgroundColor={item?.graphics?.iconbg}
                        shadow={item?.graphics?.iconshadow}
                        left={item.left}
                        top={item?.top}
                      >
                        {item.instructor_approved === false && item.assessment_only === true && (
                          <>
                            <PendingRing
                              style={{
                                top: '-6px',
                                left: '-6px',
                                width: '195px',
                                height: '195px',
                              }}
                            />
                            <PendingLabel
                              style={{
                                left: '50%',
                                bottom: '-24px',
                                transform: 'translateX(-50%)',
                              }}
                            >
                              ⏳ Pending Approval
                            </PendingLabel>
                          </>
                        )}
                      </RoadmapItem>
                    </StyledTooltip>
                  ) : (
                    // <img
                    //   onClick={() => {
                    //     redirectDetail(item);
                    //   }}
                    //   style={{
                    //     position: 'absolute',
                    //     left: item.left,
                    //     top: '40%',
                    //     cursor: 'pointer',
                    //   }}
                    //   src={ActiveImage}
                    //   alt=""
                    // />
                    <img
                      key={index}
                      style={{ marginLeft: '400px' }}
                      src={CompletedImage}
                      alt=""
                    />
                  )}
                </>
              ))}
            </>
          )}
        </CustomFlex>
      </FlexBox>
    </>
  );
}
